"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartApi = void 0;
var CartApi = /** @class */ (function () {
    /* @ngInject */
    CartApi.$inject = ["HttpFacade", "topology", "clientConfig", "$q", "experimentManager", "CommandsExecutorFactory"];
    function CartApi(HttpFacade, topology, clientConfig, $q, experimentManager, CommandsExecutorFactory) {
        this.HttpFacade = HttpFacade;
        this.topology = topology;
        this.clientConfig = clientConfig;
        this.$q = $q;
        this.experimentManager = experimentManager;
        this.CommandsExecutorFactory = CommandsExecutorFactory;
    }
    CartApi.prototype.getBasicReplacements = function () {
        var replacements = {
            storeId: this.clientConfig.storeId,
        };
        return replacements;
    };
    CartApi.prototype.removeCartItem = function (cartItemId) {
        var postData = {
            cartItemId: cartItemId,
        };
        var commandExecutor = new this.CommandsExecutorFactory();
        return commandExecutor.executeSingleCommand(this.topology.cartStoreFrontCommandsUrl, 'RemoveCartItemCommand', postData);
    };
    CartApi.prototype.addToCart = function (productId, optionsSelections, quantity, customTextFields) {
        if (customTextFields === void 0) { customTextFields = []; }
        var postData = {
            productId: productId,
            quantity: quantity,
        };
        if (Array.isArray(optionsSelections)) {
            postData.optionsSelections = optionsSelections;
        }
        else {
            postData.optionsSelectionsByNames = optionsSelections;
        }
        postData.freeText = customTextFields.map(function (customTextFieldAnswer) {
            return {
                title: customTextFieldAnswer.customText.title,
                value: customTextFieldAnswer.answer,
            };
        });
        var commandExecutor = new this.CommandsExecutorFactory();
        return commandExecutor.executeSingleCommand(this.topology.cartStoreFrontCommandsUrl, 'AddCartItemCommand', postData);
    };
    CartApi.prototype.updateCartItemQuantity = function (cartItemId, quantity) {
        var postData = {
            cartItemId: cartItemId,
            quantity: quantity,
        };
        var commandExecutor = new this.CommandsExecutorFactory();
        return commandExecutor.executeSingleCommand(this.topology.cartStoreFrontCommandsUrl, 'UpdateCartItemCommand', postData);
    };
    return CartApi;
}());
exports.CartApi = CartApi;
